/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Membership_Confirmations_StartingInputs */

const en_admin_membership_confirmations_starting = /** @type {(inputs: Admin_Membership_Confirmations_StartingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Starting`)
};

const nl_admin_membership_confirmations_starting = /** @type {(inputs: Admin_Membership_Confirmations_StartingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start`)
};

/** @type {(inputs: Admin_Membership_Confirmations_StartingInputs) => LocalizedString} */
const de_admin_membership_confirmations_starting = en_admin_membership_confirmations_starting;

/** @type {(inputs: Admin_Membership_Confirmations_StartingInputs) => LocalizedString} */
const es_admin_membership_confirmations_starting = en_admin_membership_confirmations_starting;

/** @type {(inputs: Admin_Membership_Confirmations_StartingInputs) => LocalizedString} */
const fr_admin_membership_confirmations_starting = en_admin_membership_confirmations_starting;

/** @type {(inputs: Admin_Membership_Confirmations_StartingInputs) => LocalizedString} */
const it_admin_membership_confirmations_starting = en_admin_membership_confirmations_starting;

/** @type {(inputs: Admin_Membership_Confirmations_StartingInputs) => LocalizedString} */
const pt_br2_admin_membership_confirmations_starting = en_admin_membership_confirmations_starting;

/** @type {(inputs: Admin_Membership_Confirmations_StartingInputs) => LocalizedString} */
const pl_admin_membership_confirmations_starting = en_admin_membership_confirmations_starting;

/** @type {(inputs: Admin_Membership_Confirmations_StartingInputs) => LocalizedString} */
const hu_admin_membership_confirmations_starting = en_admin_membership_confirmations_starting;

/** @type {(inputs: Admin_Membership_Confirmations_StartingInputs) => LocalizedString} */
const ro_admin_membership_confirmations_starting = en_admin_membership_confirmations_starting;

/**
* | output |
* | --- |
* | "Starting" |
*
* @param {Admin_Membership_Confirmations_StartingInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_membership_confirmations_starting = /** @type {((inputs?: Admin_Membership_Confirmations_StartingInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Membership_Confirmations_StartingInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_membership_confirmations_starting(inputs)
	if (locale === "de") return de_admin_membership_confirmations_starting(inputs)
	if (locale === "es") return es_admin_membership_confirmations_starting(inputs)
	if (locale === "fr") return fr_admin_membership_confirmations_starting(inputs)
	if (locale === "nl") return nl_admin_membership_confirmations_starting(inputs)
	if (locale === "it") return it_admin_membership_confirmations_starting(inputs)
	if (locale === "pt-BR") return pt_br2_admin_membership_confirmations_starting(inputs)
	if (locale === "pl") return pl_admin_membership_confirmations_starting(inputs)
	if (locale === "hu") return hu_admin_membership_confirmations_starting(inputs)
	return ro_admin_membership_confirmations_starting(inputs)
});
export { admin_membership_confirmations_starting as "admin.membership_confirmations.starting" }